import { useEffect } from "react";
import Header from "../../components/AdminPortal/Header/Header";
import AddAssignmentComponent from "../../components/AdminPortal/Assignment/AddAssignment";

export default function AddAssignment() {
  useEffect(() => {
    document.title = "Add Assignment - LWS Learning Portal";
  }, []);
  return (
    <>
      <Header />
      <section className="py-6 bg-primary ">
        <div className="mx-auto px-5 lg:px-0" style={{ maxWidth: "45%" }}>
          <h4 className="mb-8 text-xl font-bold text-center">
            Assign Assignment
          </h4>
          <AddAssignmentComponent />
        </div>
      </section>
    </>
  );
}
